





import Group from '@/types/Group.interface'
import GroupForm from '@/components/GroupForm.vue'
import Vue from 'vue'
import { goBack } from '@/utility/helpers'
export default Vue.extend({
    components: { GroupForm },
    data() {
        return {
            loading: false,
            toolbar: {
                title: 'Groups',
                back: () => {
                    //  Get the group form's current step
                    //  @ts-ignore
                    const step = this.$refs.groupForm.step

                    //  Use route handling for step 1, or route to the correct form step
                    //  @ts-ignore
                    if (step === 1) this.routeBack() 
                    //goBack()
                    //  @ts-ignore
                    if (step === 2) this.$refs.groupForm.step = 1
                    //  @ts-ignore
                    if (step === 3) this.$refs.groupForm.step = 1
                }
            }
        }
    },
    methods: {
        async groupCreate(group: Group): Promise<void> {
            //  Disable the form
            this.loading = true

            //  Post the grorup the API
            const response = await this.$store.dispatch('groupsPost', group)

            //  Enable the form
            this.loading = false

            //  If the request failed, no nothing
            if (!response) return

            //  If query includes a goto, push to that view
            //  after group is created with group id attached to query param
            if (this.$route.query.goto)
                this.$router.push(`${this.$route.query.goto}?group=${response.id}`)
            //  Navigate to the new group
            else this.$router.push(`/groups/${response.id}`)

            //  Notify the user of success
            this.$store.commit('appNotificationBarSet', { message: 'Group Created' })
        },
        routeBack(): void {
            //  If goto query exists, route to it
            if (this.$route.query.goto) this.$router.push(this.$route.query.goto)

            //  Else, use global goBack()
            else this.$router.back()
        }
    }
})
